module.exports = __webpack_public_path__ + "img/logo.a8c07d26.svg";